/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProviderComponentNetwork { 
    /**
     * Component url
     */
    url: string;
    /**
     * Component ip
     */
    ip?: string;
    /**
     * Component health url
     */
    health_url?: string;
    /**
     * Component pairing url
     */
    pairing_url?: string;
    /**
     * Component health url
     */
    support_url?: string;
}

